import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { openNotification } from "src/components/helpers/notification";
import ax from "src/store/config";

const initialState = {
  trainSchedList: null,
  trainSchedListLoading: false,
};

export const trainSchedAction = createAsyncThunk(
  "trainSchedAction",
  async (payload, { dispatch }) => {
    dispatch(setTrainSchedListLoading(true));
    try {
      let data;
      switch (payload.flag) {
        case "get":
          ({ data } = await ax.get("/api/admin/directory/employWorktimes", {
            params: payload.value,
          }));
          data && dispatch(setTrainSchedListLoading(false));
          return data;

        case "post":
          ({ data } = await ax.post(
            "/api/admin/directory/editEmployWorktimes",
            payload.value
          ));
          data &&
            openNotification({
              type: "success",
              message: `Время успешно отредактировано`,
            });
          break;

        case "put":
          ({ data } = await ax.put(
            "/api/admin/directory/addEmployWorktimes",
            payload.value
          ));
          data &&
            openNotification({
              type: "success",
              message: `Время успешно добавлено`,
            });
          break;

        case "delete":
          ({ data } = await ax.delete(
            "api/admin/directory/deleteEmployWorktimes",
            { params: payload.value }
          ));
          data &&
            openNotification({
              type: "success",
              message: `Время успешно удалено`,
            });
          break;

        default:
          break;
      }
    } catch (error) {
      dispatch(setTrainSchedListLoading(false));
      openNotification({
        type: "error",
        message: `Ошибка ${error.response.data.errorMessages[0].errorCode}. ${error.response.data.errorMessages[0].errorMessage}`,
      });
      return error;
    }
  }
);

const TrainSchedSlice = createSlice({
  name: "trainSched",
  initialState,
  reducers: {
    setTrainSchedListLoading: (state, action) => {
      state.trainSchedListLoading = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(trainSchedAction.fulfilled, (state, action) => {
      state.trainSchedList = action.payload;
    });
  },
});

export const { setTrainSchedListLoading } = TrainSchedSlice.actions;

export default TrainSchedSlice.reducer;
